import React, { Component } from "react";
import EventBus from "eventing-bus";
import { ACTION_TYPES } from "src/constants";
import { Loader, Header } from "src/components";
import { Form, Formik } from "formik";
import moment from "moment";
import { TextInputOne, ButtonOne } from "src/components/form-inputs";
import { withRouter } from "react-router-dom";
import WhatsappJourneysTable from "./whatsapp-journeys-table";
import { Container } from "../../../../components";
// import CreateGenericLink from "./create-generic-link";
// import GeneratedLink from "./generated-link";
import styles from "./_whatsapp-journeys.module.scss";

class WhatsappJourneys extends Component {
  state = {
    isLoading: false,
    pageNumber: 1,
    showCreateModal: false,
    showGeneratedLinkModal: false,
    search: "",
  };

  componentDidMount() {
    this.requestWhatsappJourneysSubscription = EventBus.on(
      ACTION_TYPES.REQUEST_WHATSAPP_JOURNEYS,
      () => this.setState({ isLoading: true })
    );
    this.WhatsappJourneysSubscriptionSuccess = EventBus.on(
      ACTION_TYPES.REQUEST_WHATSAPP_JOURNEYS_SUCCEEDED,
      this.handleFetchSuccess
    );
    this.WhatsappJourneysSubscriptionFailure = EventBus.on(
      ACTION_TYPES.REQUEST_WHATSAPP_JOURNEYS_FAILED,
      () => this.setState({ isLoading: false })
    );

    this.props.requestWhatsappJourneys({});
  }

  componentWillUnmount() {
    this.requestWhatsappJourneysSubscription();
    this.WhatsappJourneysSubscriptionSuccess();
    this.WhatsappJourneysSubscriptionFailure();
  }

  handleFetchSuccess = (data) => {
    this.setState({ isLoading: false });
  };

  openCreateEditModal = () => {
    this.setState({ showCreateModal: true });
  };

  closeCreateEditModal = () => {
    this.setState({ showCreateModal: false });
  };

  handleOnCompleteCreateGenericLink = () => {
    this.setState({ showCreateModal: false, showGeneratedLinkModal: true });
  };

  handleOnCompleteGeneratedLink = () => {
    this.setState({ showGeneratedLinkModal: false }, () => {
      this.props.requestAdminCreateGenericLinkClear();
      this.props.requestAdminGenericLinksList({
        page: this.state.pageNumber,
      });
    });
  };

  handleSearch = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { isLoading, showCreateModal, showGeneratedLinkModal, search } = this.state;
    const { whatsappJourneys } = this.props;
    let regex = new RegExp(search, "i");
    const filteredData = whatsappJourneys
    console.log(filteredData)
    return (
      <div className={styles["one-time-transactions"]}>
        <Header title="Whatsapp Journeys" />
        <Container>
          <div className={styles["search-box"]}>
            <Formik initialValues={{ search: "" }}>
              <Form>
                <div className={styles["search-input-box"]}>
                  <TextInputOne
                    name="search"
                    id="search"
                    type="text"
                    value={search}
                    onChange={this.handleSearch}
                    inputType={"onlysomecharactersallowed"}
                    placeholder="Search by entering ID or transaction Fund Name....."
                  />
                  <div className={styles["search-icon"]}>
                    <img src="/img/search.svg" alt="search" />
                  </div>
                </div>
              </Form>
            </Formik>
          </div>
          <div className={styles["table-data"]}>
            <WhatsappJourneysTable
              data={filteredData || []}
              handlePaginationChange={this._handlePaginationChange}
              totalItems={_.size(whatsappJourneys) || 0}
            />
          </div>

          <div className={styles["divider"]} />
          <div className={styles["footer"]}>
            <ButtonOne onClick={this.openCreateEditModal}>
              <img
                src="/img/plusnew.svg"
                alt="plus"
                className={styles["plus-btn"]}
              />
              <div>Create New Journey</div>
            </ButtonOne>
          </div>
        </Container>
        {/*{showCreateModal && (
          <CreateWhatsappJourney
            show={showCreateModal}
            handleOnCompleteCreateGenericLink={
              this.handleOnCompleteCreateGenericLink
            }
            handleClose={this.closeCreateEditModal}
          />
        )}*/}
        {/*<GeneratedLink
          show={showGeneratedLinkModal}
          handleOnCompleteGeneratedLink={this.handleOnCompleteGeneratedLink}
        />*/}
        <Loader loading={isLoading} />
      </div>
    );
  }
}

export default withRouter(WhatsappJourneys);
